<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Monitor from "@/services/Monitor";

    export default {
        components: { Layout, PageHeader },
        page: {
            title: "Check Email",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Email Check",
                showLoader: false,
                tryingToValidate: false,
                email: "",
                message: "",
                result: null,
                items: [
                    { text: "Home", href: "/" },
                    { text: "Email Check", active: true }
                ],
                error: null
            };
        },
        middleware: "authentication",
        methods: {
            async checkEmail() {
                if (!this.email) {
                    this.error = "Please enter an email address";
                    return;
                }

                // Basic email validation
                if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
                    this.error = "Please enter a valid email address";
                    return;
                }

                this.error = null;
                this.tryingToValidate = true;
                this.result = null;
                this.message = "Check email address. This may take a few moments...";

                try {
                    const res = await Monitor.checkEmail(this.email);
                    this.result = res.data;
                    this.message = "";
                } catch (err) {
                    this.message = "An error occurred while check the email address.";
                    console.error(err);
                } finally {
                    this.tryingToValidate = false;
                }
            },
        },
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />

        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title mb-4">Email Check Tool</h4>

                        <form @submit.prevent="checkEmail">
                            <div class="form-group">
                                <label for="email" class="form-label">Email Address</label>
                                <div class="input-group">
                                    <input
                                            id="email"
                                            v-model.trim="email"
                                            type="email"
                                            class="form-control form-control-lg"
                                            placeholder="user@example.com"
                                            :disabled="tryingToValidate"
                                            @input="error = null"
                                    >
                                    <button
                                            class="btn btn-primary"
                                            type="submit"
                                            :disabled="tryingToValidate"
                                    >
                                        <span v-if="!tryingToValidate">Check</span>
                                        <span v-else>
                                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                            Checking...
                                        </span>
                                    </button>
                                </div>
                                <small v-if="error" class="text-danger">{{ error }}</small>
                                <small class="form-text text-muted">
                                    Enter the email address you want to check
                                </small>
                            </div>
                        </form>

                        <div v-if="message" class="alert alert-info mt-3 d-flex align-items-center">
                            <i class="bx bx-info-circle me-2"></i>
                            {{ message }}
                        </div>

                        <div v-if="result" class="mt-4">
                            <div class="d-flex justify-content-between align-items-center mb-3">
                                <h5 class="mb-0">Check Results</h5>
                                <span class="badge bg-success rounded-pill">Completed</span>
                            </div>

                            <div class="card border-light">
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <h6 class="text-muted">Email Address</h6>
                                                <p class="mb-0 text-break">{{ result.email.email }}</p>
                                            </div>
                                        </div>
                                        <div class="col-md-6">
                                            <div class="mb-3">
                                                <h6 class="text-muted">Found In</h6>
                                                <div v-if="result.found_in.length > 0">
                                                    <span v-for="(source, index) in result.found_in"
                                                          :key="index"
                                                          class="badge bg-light text-dark me-1 mb-1">
                                                        {{ source }}
                                                    </span>
                                                </div>
                                                <p v-else class="mb-0 text-success">
                                                    <i class="bx bx-check-circle"></i> Not found in any tenant
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="mt-3 text-end">
                                <button class="btn btn-outline-secondary" @click="result = null">
                                    Clear Results
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </Layout>
</template>

<style scoped>
    .card {
        border-radius: 10px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    }

    .form-control-lg {
        height: calc(2.875rem + 2px);
    }

    .badge {
        font-size: 0.85em;
    }

    .text-break {
        word-break: break-all;
    }
</style>